import React from 'react'

import SEO from '../components/shared/SEO'
import SecurityTemplate from '../components/templates/SecurityTemplate'

const Security = () => (
  <>
    <SEO
      title="情報セキュリティ方針 | RYDE株式会社"
      description="RYDE株式会社の情報セキュリティ方針です。"
      openGraph={{
        images: [
          {
            url: 'https://ryde-inc.jp/og_image.png',
          },
        ],
        type: 'article',
        url: 'https://ryde-inc.jp/',
        site_name:
          'RYDE株式会社 | 二次交通をわかりやすく、使いやすく、そして持続可能に',
        locale: 'ja_JP',
      }}
    />
    <SecurityTemplate />
  </>
)

export default Security
